import {PlatformDataType} from 'src/interfaces/Platform.interface'

export type DashboardPendingOrderAction =
  | 'failed_order_sync'
  | 'pending_orders'
  | 'to_be_shipped'

export type DashboardPendingAction =
  | DashboardPendingOrderAction
  | 'linked_items'
  | 'unlinked_items'
  | 'inventory_mismatch'

const ORDER_PENDING_ACTIONS = new Set<DashboardPendingOrderAction>([
  'failed_order_sync',
  'pending_orders',
  'to_be_shipped',
])

export const isDashboardPendingOrderAction = (
  value: string | null | undefined
): value is DashboardPendingOrderAction =>
  !!value && ORDER_PENDING_ACTIONS.has(value as DashboardPendingOrderAction)

/** Destination sales channels — same scope as Order Report platform dropdown. */
export const getDashboardDestinationPlatforms = (
  connectedPlatforms: PlatformDataType[] = []
): PlatformDataType[] =>
  connectedPlatforms.filter(
    (channel) =>
      !(channel?.isMainStore || channel?.isAccountingStore || channel?.isShippingStore)
  )

export const resolvePlatformForNavigation = (
  connectedPlatforms: PlatformDataType[] = [],
  platformIdHint: string
): PlatformDataType | null => {
  const destinationPlatforms = getDashboardDestinationPlatforms(connectedPlatforms)

  if (platformIdHint) {
    const match = destinationPlatforms.find((p) => String(p.id) === String(platformIdHint))
    if (match) return match

    return (
      connectedPlatforms.find((p) => String(p.id) === String(platformIdHint)) ?? null
    )
  }

  return destinationPlatforms[0] ?? null
}

export function buildPendingActionPath(
  action: DashboardPendingAction,
  platformIdHint: string,
  connectedPlatforms: PlatformDataType[] = []
): string | null {
  const platform = resolvePlatformForNavigation(connectedPlatforms, platformIdHint)

  switch (action) {
    case 'failed_order_sync':
    case 'pending_orders':
    case 'to_be_shipped':
      return `/orders-all/?from=dashboard_card&pending_action=${action}`

    case 'linked_items':
    case 'unlinked_items': {
      const platformInfoId = platform?.platform_info?.id
      if (!platformInfoId || !platform?.id) return null
      return `/listing-product-table/${platformInfoId}/${platform.id}`
    }

    case 'inventory_mismatch':
      return '/inventory-logs'

    default:
      return null
  }
}
